import BadgesComponent from '@components/common/Badges';
import Button from '@components/common/Button';
import CommonFormFields from '@pages/Forms/CommonFormFields';
import React, { useEffect,  useState } from 'react';
import { InputGroup, Modal } from 'react-bootstrap';
import PlusSvgIcon from '../../../../assets/svg_main/plus.svg';
import './index.css'
import VectorIcon from '../../../../assets/svg/Vector.svg'
import { COMMON_CONSTANTS, dateFormate, pregnancyFormData } from '@constants/index';
import endpoints from '@config/endpoints';
import { getData, getDataWithCache, postDataJSON } from '../../../../services/CommonApiService';
import { useParams } from 'react-router-dom';
import PregnancyServices from './PregnancyServices';
import { useSelector } from 'react-redux';
import { RootState } from '@store/reducers';
import { PagePermission } from '@services/usePermission';
import dayjs from 'dayjs';
import config from '@config/config';
import { setPregnancyId, setShowPregnancy, setShowServices,setPregnancyOngoing, setIsPregnant, updateAncService } from '@store/actions/beneficiaryAction';
import PNCModal from '../PNC/PNCModal';
import { setCheckIsHrp, updatePNC } from '@store/actions/beneficiaryAction';
import { errorLogger } from '@utils/applicationLogUtils';
import { ancPeriodDateCalculation } from '../ANC/Forms/CreateAndEdit/AncDateCaluculation';
import {
    setBeneficiaryDetails
} from '@store/actions/beneficiaryAction';
import { useDispatch } from 'react-redux';
import usePregnancyTabBack from '../usePregnancyTabBack';
import PregnancyAddServices from './PregnancyAddServices';
import { buttonNames } from '@constants/appConstants';
import { DatePicker } from 'antd';
import InfoBar from '@components/common/InfoBars';
import { benef_const, benef_life_calendar_const } from '@constants/beneficiaryConstant';
import { PNC_COMMON_CONSTANTS } from '../PNC/PNCConstants';
import PregnancyActionButtons from './PregnancyActionButtons';
import { calculateANCPeriods, diffBetweenTwoDays, subtractDaysFromDate } from '@utils/commonUtils';
import FormatDate from '@utils/dateFormat';
import { COMMON_ABORTION_CONSTANTS } from '../Abortion/AbortionConstants';
import { PREGNANCY_COMMON_CONSTANTS } from '@constants/ancConstants';
import PregnancyOutcome from './pregnancyOutcome/pregnancyOutcome';
import { getPNCDetails } from '../DeliveryOutcome/constants/DeliveryConstants';
import { useServiceRuleValue } from '@hooks/useServiceRuleMaster';
import { decodeWithKeyAndShift, encodeWithKeyAndShift } from '@utils/base64Utils';
interface objectTypes {
    isError: boolean,
    message: string,
    isDisable: boolean,
    value: any,
    id?: any,
    verifiedDetails?: any
    code?: any,
    compositeId?: any
}

interface formStateType {
    [key: string]: objectTypes
}

const PregnancyTracking = () => {
    const [showModal, setShowModal] = useState<boolean>(true);
    const { id } = useParams();
    const todayDate = new Date()
    const [benfDetails] = useSelector((state: RootState) => state.beneficiary.beneficiaryDetails);
    const showPregnancyForm=useSelector((state: RootState) => state.beneficiary.showPregnancy);
    const showPregnancyServices=useSelector((state: RootState) => state.beneficiary.showServices);
    const pregnancyOngoing= useSelector((state: RootState) => state.beneficiary.pregnancyOngoing);
    const currPregnancyId= useSelector((state: RootState) => state.beneficiary.currPregnancyId);
    const beneficiaryPregnancyHistoryFromStore = useSelector((state: RootState) => state.beneficiary.beneficiaryPregnancyHistory);
    const userId = localStorage.getItem('userId');
    const userRole = benfDetails?.user_role || localStorage.getItem('userTypeName');
    const [showPregnancyCard, setShowPregnancyCard] = useState<boolean>(false);
    const [pregnancyTestResult, setPregnancyTestResult] = useState<string>("");
    const checkIsHRP = useSelector((state: RootState) => state.beneficiary.checkIsHRP);
    const [loading, setLoading] = useState<boolean>(false);
    const earlyPrimigravidaAge = useServiceRuleValue('hrp-rules', 'primigravida_age_early_primigravida.value');
    const elderlyPrimigravidaAge = useServiceRuleValue('hrp-rules', 'primigravida_age_elderly_primigravida.value');    
    const [preganacyStatusData, setPregnancyStatusData] = useState([]);
    const [pregnancyBenfFormData, setPregnancyBenfFormData] = useState<any>(pregnancyFormData);
    const [lmpDate, setLmpDate] = useState<any>('');
    const [showLoader, setShowLoader] = useState<boolean>(true);
    const [pregnancyFormState, setPregnancyFormState] = useState<formStateType>({
        result: {
            isError: false,
            message: '',
            isDisable: false,
            value: '',
        },
        firstPregnancy: {
            isError: false,
            message: '',
            id: '',
            isDisable: false,
            value: '',
        },
        dateOfRegistration: {
            isError: false,
            message: '',
            isDisable: false,
            value: '',
        },
        jsy: {
            isError: false,
            message: '',
            id: '',
            isDisable: false,
            value: '',
        },
        facilityType: {
            isError: false,
            message: '',
            isDisable: false,
            value: '',
        },
        facilityName: {
            isError: false,
            message: '',
            id: '',
            isDisable: false,
            value: '',
        },
         hprName: {
            isError: false,
            message: '',
            isDisable: false,
            value: '',
        },
        ashaName: {
            isError: false,
            message: '',
            id: '',
            isDisable: false,
            value: '',
        }
    })
    const [numberOfPregnancy, setNumberOfPregnancy] = useState<any>(null);
    const [totalChildrenLive, setTotalChildrenLive] = useState<any>(null);
    const [totalFemaleChild, setTotalFemaleChild] = useState<any>(null);
    const [outcomes, setOutcomes] = useState<any[]>([]);
    const [lmpDateError,setLmpDateError]= useState<boolean>(false);
    const [isLMPDateDisable,setIsLMPDateDisable]= useState<boolean>(true);
    const tenMonthsAgo = new Date(new Date());
    tenMonthsAgo.setDate(new Date().getDate() - 304);
    const tenMonthAgoDate = dayjs(tenMonthsAgo);
    const [minimimDate, setMinimimDate] = useState<any>(tenMonthAgoDate);
    const [maximumDate, setMaximumDate] = useState<any>(dayjs(new Date()).subtract(35, 'day'));
    const [showANCModal, setShowANCModalFromTrackingPage] = useState<boolean>(false);
    const [serviceItems, setServiceItems] = useState<any>();
    const [serviceData, setServiceData] = useState<any>();
    const [isPregnancyClosed, setIsPregnancyClosed] = useState<boolean>(false);
    const canViewPregnancyOverview = PagePermission("Benf_Service", "Service_OVPg");
    const handlePregnancyTabBack = usePregnancyTabBack();
    const dispatch = useDispatch();

    const pageMenuFromLifeCalendar = useSelector(
        (state: RootState) => state?.beneficiary?.pageMenuFromLifeCalendar,
    );
    const benefPregnancyDetails = useSelector((state: RootState) => state.beneficiary.pregnancyDetails);
    const storeUserId = localStorage.getItem('userId');
    const pregnancyStatusOptions = localStorage.getItem('pregnancyStatusOptions');
    const fetchPregnancyStatus = async () => {
        setLoading(true);
        let pregnancyStatus: any = [];
        try {
            if (storeUserId && pregnancyStatusOptions) {
                pregnancyStatus = JSON.parse(decodeWithKeyAndShift(pregnancyStatusOptions));
            } else {
                const pregnancyStatusResponse = await getDataWithCache<any>(`${endpoints.getPregnancyStatus}`);
                pregnancyStatus = pregnancyStatusResponse?.data
                localStorage.setItem('pregnancyStatusOptions', encodeWithKeyAndShift(JSON.stringify(pregnancyStatus)));
            }
            setPregnancyStatusData(pregnancyStatus);
            setLoading(false);
        } catch (error: any) {
            setLoading(false);
            errorLogger(error?.response?.data || error?.response || error)
        }
    }

    const addPregnancyOnClick = async () => {
        setShowPregnancyCard(true);
        fetchPregnancyStatus();
    }

    const handleBackClick = () => {
        setShowPregnancyCard(false);
    }

    const handleDiscardClick = () => {
        setShowPregnancyCard(false);
    }

    const handleTestResultSelection = (result: string) => {
        setPregnancyTestResult(result);
    }

    useEffect(() => {
        if(!pregnancyOngoing) {
            fetchServiceContent();
            dispatch(updatePNC('currPregnancyId', ''));
        }
    },[pregnancyOngoing]);

     useEffect(() => {
            handlePregnancyFormChange(dayjs(), 'dateOfRegistration', 'initialFetch');
        },[]);
    useEffect(() => {
        showPregnancyForm && getFacilityData();
    },[showPregnancyForm]);
        
        const getFacilityData = async () => {
            try {
                const facilityDetailsRespone = await getDataWithCache<any>(`${endpoints.getLinkedFacilitiesByUserById}/${userId}`);
                const parentFacility = facilityDetailsRespone.data[0]?.find((item: any) => item.is_parent === true,);
                const facilityTypeOptions = facilityDetailsRespone?.data[0]?.map((key: any) => ({
                    value: key.facility_type_name,
                    label: key.facility_type_name,
                    id: key.facility_type_id,
                    code: key.facility_type_code,
                }),
                );
                const facilityNameOptions = facilityDetailsRespone?.data[0]?.map((key: any) => ({
                    value: key.facility_name,
                    label: key.facility_name,
                    id: key.facility_id,
                    code: key.facility_code,
                }))
    
                setPregnancyFormState((prevState: any) => ({
                    ...prevState,
                    facilityName: {
                        ...prevState.facilityName,
                        value: parentFacility?.facility_name,
                        id: parentFacility?.facility_id,
                    },
                    facilityType: {
                        ...prevState.facilityType,
                        value: parentFacility?.facility_type_name,
                        id: parentFacility?.facility_type_id,
                    },
                }));
                setPregnancyBenfFormData((prevState: any) => {
                    return {
                        ...prevState,
                        facilityType: {
                            ...prevState.facilityType,
                            '#options': facilityTypeOptions,
                        },
                        facilityName: {
                            ...prevState.facilityName,
                            '#options': facilityNameOptions,
                        },
                    };
                });
                fetchHprName(parentFacility?.facility_id);
            } catch (error: any) {
                errorLogger(error?.response?.data || error?.response || error)
            }
        }
    
    const fetchHprName = async (id: any) => {
        if (id) {
            try {
                const Health_provider = await getDataWithCache<any>(`${endpoints.getHealthProviderTagged(id)}`);
                const healthProviderOptions = Health_provider?.data?.map((key: any) => ({
                    value: `${key?.f_name} ${key?.l_name}`,
                    label: `${key?.f_name} ${key?.l_name}`,
                    id: key?.user_id,
                    code: key?.user_code,
                    ufTaggedId: key?.uf_tagged_id,
                }));
                setPregnancyBenfFormData((prevState: any) => {
                    return {
                        ...prevState,
                        hprName: {
                            ...prevState.hprName,
                            '#options': healthProviderOptions,
                        },
                    };
                });
            } catch (error: any) {
                errorLogger(error?.response?.data || error?.response || error)
            }
        }
    };

    useEffect(() => {
        isPregnancyOngoing();
    }, [benfDetails, pregnancyOngoing,beneficiaryPregnancyHistoryFromStore]); 
    //FUTURE: Commennted, if requirement changes in future
    // const isPregnancyPeriodOver = (pregnancyDetails:any) => {
    //     return diffBetweenTwoDays(pregnancyDetails?.data?.[0]?.pregnancy_closure_date, dayjs(), 'day') >= 134;
    // }

    const isPregnancyOngoing = async () => {
        setShowLoader(true);
        setLoading(true);
        try {
            if (pageMenuFromLifeCalendar?.isNavigateFromLifeEvent && !pageMenuFromLifeCalendar.currentServices && (pageMenuFromLifeCalendar.naviGationType === benef_life_calendar_const.pregnancyStatus.abortion || pageMenuFromLifeCalendar.naviGationType === benef_life_calendar_const.pregnancyStatus.still_birth || pageMenuFromLifeCalendar.naviGationType === benef_life_calendar_const.pregnancyStatus.success)) {
                setIsPregnancyClosed(true);
                handlePregnancyTabBack();
                setShowLoader(false);
            } else {
                const pregnancyDetails = await beneficiaryPregnancyHistoryFromStore;
                const moduleCode = pregnancyDetails?.data?.[0]?.module_code;
                dispatch(updatePNC("moduleCode", moduleCode));
                dispatch(updatePNC("pregHistoryDetails", pregnancyDetails?.data?.[0]));

                const isPreviousPregnancyRecord = moduleCode === PNC_COMMON_CONSTANTS.PREVIOUS_PREGNANCY;
                if (pregnancyDetails?.data?.length && !isPreviousPregnancyRecord) {
    const isAutoClosedPregnancy = moduleCode === PNC_COMMON_CONSTANTS.AUTO_CLOSURE_PREGNANCY;
    const pregClosureDate = pregnancyDetails?.data?.[0]?.pregnancy_closure_date;
    const deliveryDate = pregnancyDetails?.data?.[0]?.delivery_date;

    let latestServiceDate: any = null;

    if (isAutoClosedPregnancy) {
        latestServiceDate = await fetchLatestAncServiceDate(pregnancyDetails?.data?.[0]?.pregnancy_id);
    }

    handleLmpDateValidation(
        pregClosureDate,
        isAutoClosedPregnancy,
        latestServiceDate,
        deliveryDate,
    );
    setPregnancyBenfFormData((prevState: any) => {
        const newState = { ...prevState };
        delete newState.firstPregnancy;
        return newState;
    });

    const daysSinceDelivery = deliveryDate ? dayjs().diff(dayjs(deliveryDate), 'day') : null;
    const isDeliveryEligible = !!deliveryDate && daysSinceDelivery !== null && daysSinceDelivery >= 35;
    const isClosedWithoutDelivery = moduleCode === PNC_COMMON_CONSTANTS.CLOSE_PREGNANCY && !deliveryDate;
    const isAlreadyClosed = (!!pregClosureDate && !deliveryDate) || pregnancyDetails?.data?.[0]?.is_pregnancy_outside_rch === true;
    if (isDeliveryEligible || isClosedWithoutDelivery || isAlreadyClosed || moduleCode === PNC_COMMON_CONSTANTS.ABORTION_DETAILS || isAutoClosedPregnancy) {
                        pregnancyOngoing && dispatch(setPregnancyOngoing(false));
                        setIsPregnancyClosed(true);
                        handlePregnancyTabBack();
                        setShowLoader(false);
                    } else {
                        !pregnancyOngoing && dispatch(setPregnancyOngoing(true));
                        setShowLoader(false);
                        setIsPregnancyClosed(false);
                        dispatch(setPregnancyId(pregnancyDetails?.data?.[0].pregnancy_id));
                    }
                }
                else {
                    pregnancyOngoing && dispatch(setPregnancyOngoing(false));
                    setIsPregnancyClosed(false);
                    handlePregnancyTabBack();
                    setShowLoader(false);
                }
            }
            setLoading(false);
        }
        catch (error) {
            setLoading(false);                              
            dispatch(setPregnancyOngoing(false));
            setShowLoader(false);

        }
    };
    useEffect(()=>{
        dispatch(setShowPregnancy(false))
        setIsLMPDateDisable(true);
        setPregnancyFormState({
            result: {
                isError: false,
                message: '',
                isDisable: false,
                value: '',
            },
            firstPregnancy: {
                isError: false,
                message: '',
                id: '',
                isDisable: false,
                value: '',
            },
            dateOfRegistration: {
                isError: false,
                message: '',
                isDisable: false,
                value: '',
            },
            jsy: {
                isError: false,
                message: '',
                id: '',
                isDisable: false,
                value: '',

            },
            facilityType: {
            isError: false,
            message: '',
            isDisable: false,
            value: '',
        },
        facilityName: {
            isError: false,
            message: '',
            id: '',
            isDisable: false,
            value: '',
        },
         hprName: {
            isError: false,
            message: '',
            isDisable: false,
            value: '',
        },
        ashaName: {
            isError: false,
            message: '',
            id: '',
            isDisable: false,
            value: '',
        }
        });
    },[])

    const getLastLmpDate = async (pregnancyDetails:any) => {
        if(pregnancyDetails?.length) {
            const validPregnancyDetails = pregnancyDetails?.filter((detail: any) => detail.delivery_date !== null);
            if(validPregnancyDetails?.length === 0) {
                return null;
            }
            const lastDeliveryObj =  validPregnancyDetails?.reduce((latest:any, current:any) => {
                const latestDate = dayjs(latest.delivery_date);
                const currentDate = dayjs(current.delivery_date);
                return currentDate.isAfter(latestDate) ? current : latest;
            });
            return await fetchPregnancyDetails(lastDeliveryObj?.pregnancy_id);
        }
    }

    const fetchPregnancyDetails = async (pregnancyId:any) => {
        try {
            if(pregnancyId) {
                const cachedPregnancyMatches =
                    benefPregnancyDetails?.data?.length > 0 &&
                    benefPregnancyDetails?.data?.[0]?.pregnancy_id === pregnancyId;
                const pregnancyRegDetails: any = cachedPregnancyMatches ? benefPregnancyDetails :  await getData(`${endpoints.getPregnancyDetailsById}/${pregnancyId}`);
                return pregnancyRegDetails?.data?.[0]?.lmp;
            }

        }     catch(error:any){
            errorLogger(error?.response?.data||error?.response||error)
        }
    }

    const fetchLatestAncServiceDate = async (pregnancyId: any) => {
        try {
            if (pregnancyId) {
                const cachedPregnancyMatches =
                    benefPregnancyDetails?.data?.length > 0 &&
                    benefPregnancyDetails?.data?.[0]?.pregnancy_id === pregnancyId;
                const pregnancyRegDetails: any = cachedPregnancyMatches
                    ? benefPregnancyDetails
                    : await getData(`${endpoints.getPregnancyDetailsById}/${pregnancyId}`);
                return pregnancyRegDetails?.data?.[0]?.latest_service_availed_dt || null;
            }
            return null;
        } catch (error: any) {
            errorLogger(error?.response?.data || error?.response || error);
            return null;
        }
    };
  const handleLmpDateValidation = (
    pregClosureDate: any,
    isAutoClosedPregnancy: boolean,
    latestServiceDate: any,
    deliveryDate: any,
) => {
    let computedMinLmp = tenMonthAgoDate;
    const dorFloor = dayjs().subtract(90, 'day'); 
    let computedMinDor = dorFloor;

    const latestRelevantDate = isAutoClosedPregnancy
        ? latestServiceDate
        : (deliveryDate || pregClosureDate);

    if (latestRelevantDate && dayjs(latestRelevantDate).isValid()) {
        const relevantDate = dayjs(latestRelevantDate);

        const isWithin304Days = !relevantDate.isBefore(tenMonthAgoDate);
        if (isWithin304Days) {
            computedMinLmp = relevantDate.add(1, 'day');
        }

        const isWithin90Days = !relevantDate.isBefore(dorFloor);
        if (isWithin90Days) {
            computedMinDor = relevantDate.add(1, 'day');
        }
    }

    setPregnancyBenfFormData((prevState: any) => ({
        ...prevState,
        dateOfRegistration: {
            ...prevState.dateOfRegistration,
            '#minDate': computedMinDor,
        },
    }));

    setMinimimDate(computedMinLmp);
};

    const handleSubmitTestResult = () => {
        if (pregnancyTestResult === 'Positive') {
            dispatch(setShowPregnancy(true));
            setIsPregnancyClosed(false);
            setPregnancyFormState((prevState: any) => ({
                ...prevState,
                result: {
                    ...prevState.result,
                    value: pregnancyTestResult,
                    isError: false,
                    message: '',
                },
            }))
        }
        setShowPregnancyCard(false);
        setPregnancyTestResult('');
    }

    useEffect(() => { }, [showPregnancyCard])

    // useEffect(() => {
    //     fetchServiceContent();
    //     dispatch(updatePNC('currPregnancyId', ''));
    // },[]);

    const handlePregnancyFormChange = async (value: any | boolean, key: string, id?: any, option?: any, code?: any, changedData?: any) => {
        if (key === 'dateOfRegistration') {
            if (value) {
                const maxDate = dayjs(value).subtract(beneficiaryPregnancyHistoryFromStore?.data?.[0]?.module_code === PNC_COMMON_CONSTANTS.ABORTION_DETAILS ? 0 : 35, 'day');
                setMaximumDate(maxDate);
                if (id !== 'initialFetch') {
                    setIsLMPDateDisable(false);
                }
                setLmpDate('');
            } else {
                setLmpDate('');
                setIsLMPDateDisable(true);
            }
        }

        setPregnancyFormState((prevState: any) => ({
            ...prevState,
            [key]: {
                ...prevState[key],
                value: value,
                isError: false,
                message: '',
                id: id,
                code: code
            },
        }))
        if (key === "hprName") {
            setPregnancyFormState((prevState: any) => {
                return {
                    ...prevState,
                    ashaName: {
                        ...prevState.ashaName,
                        value: '',
                    },
                };
            });
            if (value) {
                fetchAshaName(changedData?.ufTaggedId);
            } else {
                setPregnancyBenfFormData((prevState: any) => {
                    return {
                        ...prevState,
                        ashaName: {
                            ...prevState.ashaName,
                            '#options': [],
                        },
                    };
                });
            }
        }
    }

     const fetchAshaName = async (ufTaggedId: any) => {
        try {
          const ashaNameRes = await getDataWithCache<any>(`${endpoints.getMobiliserTagged(ufTaggedId)}`);
          const ashanameOptions = ashaNameRes?.data.map((key: any) => ({
            value: key?.f_name + ' ' + key?.l_name,
            label: key?.f_name + ' ' + key?.l_name,
            id: key?.mobiliser_id,
            code: key?.user_code,
          }));
          setPregnancyBenfFormData((prevState: any) => {
            return {
              ...prevState,
              ashaName: {
                ...prevState.ashaName,
                '#options': ashanameOptions,
              },
            };
          });
        } catch (error: any) {
          errorLogger(error?.response?.data || error?.response || error)
        }
      }

    const handlelmpDateChange = (value: any) => {
        setLmpDateError(false)
        if(value){
            const date = new Date(value)
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const formatedDate = `${year}-${month}-${day}`
            setLmpDate(formatedDate)
        }
        else{
            setLmpDate('')
        }
    }

    const handleSubmitForm = async () => {
        let primigravidaServiceId : string = "";
        let primigravidaHrpId : string ="";
        let treatmentStatusId : string ="";
        const isError: boolean[] = []
        const pregnancyFormStateError = {
            ...pregnancyFormState
        };
        let ispregnancyFormError = false;
        Object.keys(pregnancyFormStateError).map((item) => {
                if (!lmpDate) {
                    setLmpDateError(true)
                }
                else {
                    setLmpDateError(false)
                }
           if (item === 'firstPregnancy' && pregnancyBenfFormData.firstPregnancy) {
                if (!pregnancyFormStateError.firstPregnancy.value) {
                    ispregnancyFormError = true;
                    pregnancyFormStateError.firstPregnancy.isError = true;
                    pregnancyFormStateError.firstPregnancy.message = 'First Pregnancy is required'
                }
                else {
                    pregnancyFormStateError.firstPregnancy.isError = false;
                    pregnancyFormStateError.firstPregnancy.message = ''
                }
            } else if (item === 'facilityType' && pregnancyBenfFormData.facilityType) {
                if (!pregnancyFormStateError.facilityType.value) {
                    ispregnancyFormError = true;
                    pregnancyFormStateError.facilityType.isError = true;
                    pregnancyFormStateError.facilityType.message = 'Select Facility Type from the dropdown.'
                }
                else {
                    pregnancyFormStateError.facilityType.isError = false;
                    pregnancyFormStateError.facilityType.message = ''
                }
            } else if (item === 'facilityName' && pregnancyBenfFormData.facilityName) {
                if (!pregnancyFormStateError.facilityName.value) {
                    ispregnancyFormError = true;
                    pregnancyFormStateError.facilityName.isError = true;
                    pregnancyFormStateError.facilityName.message = 'Select Facility Name from the dropdown.'
                }
                else {
                    pregnancyFormStateError.facilityName.isError = false;
                    pregnancyFormStateError.facilityName.message = ''
                }
            } else if (item === 'hprName' && pregnancyBenfFormData.hprName) {
                if (!pregnancyFormStateError.hprName.value) {
                    ispregnancyFormError = true;
                    pregnancyFormStateError.hprName.isError = true;
                    pregnancyFormStateError.hprName.message = 'Select Health Provider Name from the dropdown.'
                }
                else {
                    pregnancyFormStateError.hprName.isError = false;
                    pregnancyFormStateError.hprName.message = ''
                }
            } 
            setPregnancyFormState(pregnancyFormStateError);
            isError[0] = ispregnancyFormError;
        });

        if(pregnancyFormState?.firstPregnancy?.value === "No") {
            if (!numberOfPregnancy) {
            setNumberOfPregnancy({
                isError: true,
                errorMessage: 'Number of pregnancy is required'
            });
            ispregnancyFormError = true;
        }

        if(outcomes.length>0){
            const temp = JSON.parse(JSON.stringify(outcomes))
            temp.forEach((item: any)=>{
                if(!item.pregnancy_closure_reason_id  || !item.pregnancy_closure_date){
                     item.error = 'Pregnancy closure reason and date is required';
                     item.maxDate = dayjs(item.maxDate)
                }
            })
            ispregnancyFormError = temp.some((item: any) => item.error !== '');
            setOutcomes(temp);
        }
        
        if(!totalChildrenLive){
            setTotalChildrenLive({
                isError: true,
                errorMessage: 'Total children ever born is required'
            });
            ispregnancyFormError = true;
        }}

        const ancPeriods = calculateANCPeriods(lmpDate);
        if (!ispregnancyFormError&&(!lmpDateError && lmpDate)) {
            try {
                const benfDob = new Date(benfDetails.dob)
                const benfLmpDate = new Date(lmpDate)
                let benfPregnAge = benfLmpDate.getFullYear() - benfDob.getFullYear();
                if (
                    benfLmpDate.getMonth() < benfDob.getMonth() ||
                    (benfLmpDate.getMonth() === benfDob.getMonth() && benfLmpDate.getDate() < benfDob.getDate())
                ) {
                    benfPregnAge--;
                }
                const getPrimigravidaDetails = async (hrpCode: string) => {
                    const serviceResponse = await getDataWithCache<any>(`${endpoints.getServiceReport}/${PREGNANCY_COMMON_CONSTANTS.PRIMIGRAVIDA_AGE}`);
                    const details = serviceResponse?.data?.find((item: any) => item.hrp_code === hrpCode);
                    if (details) {
                        primigravidaServiceId = details.service_id;
                        primigravidaHrpId = details.hrp_id;
                        const treatmentResponse = await getDataWithCache<any>(`${endpoints.getTreatmentStatus}/${PREGNANCY_COMMON_CONSTANTS.PRIMIGRAVIDA_AGE}`);
                        treatmentStatusId = treatmentResponse?.data?.[0]?.treatment_status_id;
                    }
                };
                if (
                    pregnancyFormState.firstPregnancy.value === 'Yes' &&
                    earlyPrimigravidaAge != null &&
                    elderlyPrimigravidaAge != null
                ) {
                    if (benfPregnAge < earlyPrimigravidaAge) {
                        await getPrimigravidaDetails(PREGNANCY_COMMON_CONSTANTS.EARLY_PRIMIGRAVIDA);
                    }
                    else if (benfPregnAge > elderlyPrimigravidaAge) {
                        await getPrimigravidaDetails(PREGNANCY_COMMON_CONSTANTS.ELDERLY_PRIMIGRAVIDA);
                    }
                }
                    
                    const prevPregnancyClosureDetails = outcomes?.map((item: any) => {
                    const pncDetails = getPNCDetails(item.pregnancy_closure_date);
                    return {
                        is_delivery_outside_rch:item.pregnancy_closure_reason_code === 'delivery'? true:false,
                        is_abortion_outside_rch:item.pregnancy_closure_reason_code === 'abortion'? true:false ,
                        pregnancy_closure_reason_id: item.pregnancy_closure_reason_id,
                        pregnancy_closure_date: dayjs(item.pregnancy_closure_date).format(dateFormate.yyyy_mm_dd),
                        pnc1_start_dt: pncDetails[0]?.startDate,
                        pnc1_end_dt: pncDetails[0]?.endDate,
                        pnc2_start_dt: pncDetails[1]?.startDate,
                        pnc2_end_dt: pncDetails[1]?.endDate,
                        pnc3_start_dt: pncDetails[2]?.startDate,
                        pnc3_end_dt: pncDetails[2]?.endDate,
                        pnc4_start_dt: pncDetails[3]?.startDate,
                        pnc4_end_dt: pncDetails[3]?.endDate,
                        pnc5_start_dt: pncDetails[4]?.startDate,
                        pnc5_end_dt: pncDetails[4]?.endDate,
                        pnc6_start_dt: pncDetails[5]?.startDate,
                        pnc6_end_dt: pncDetails[5]?.endDate,
                        pnc7_start_dt: pncDetails[6]?.startDate,
                        pnc7_end_dt: pncDetails[6]?.endDate,
                        }
                    });
                const payLoad = {
                    benefId: id,
                    stateId: benfDetails?.state_id,
                    lmpDate: lmpDate,
                    pregnancyRegistrationDate: FormatDate(pregnancyFormState.dateOfRegistration.value),
                    isFirstPregnancy: pregnancyFormState.firstPregnancy.value === 'Yes' ? true : false,
                    primigravidaAgeServiceId: primigravidaServiceId || null,
                    pregnancyAge: benfPregnAge || null,
                    primigravidaAgeHrpId: primigravidaHrpId|| null,
                    primigravidaAgeHrpFlag: primigravidaServiceId  ? true : false,
                    primigravidaAgeTreatmentStatusId: treatmentStatusId || null,
                    isJSYEntitled: pregnancyFormState.jsy.value || false,
                    heightServiceId: null,
                    height: null,
                    shortStatureHrpId: null,
                    shortStatureHrpFlag: null,
                    shortStatureHrpTreatmentStatusId: null,
                    flagValue: primigravidaServiceId  ? true : false,
                    facilityId:pregnancyFormState.facilityName.id,
                    anmId: pregnancyFormState.hprName.id,
                    mobiliserId: pregnancyFormState?.ashaName?.id || null,
                    parentUserId: userId,
                    firstAncStartDate: ancPeriods?.firstANC?.startDate,
                    firstAncEndDate: ancPeriods?.firstANC?.endDate,
                    secondAncStartDate: ancPeriods?.secondANC?.startDate,
                    secondAncEndDate: ancPeriods?.secondANC?.endDate,
                    thirdAncStartDate: ancPeriods?.thirdANC?.startDate,
                    thirdAncEndDate: ancPeriods?.thirdANC?.endDate,
                    fourthAncStartDate: ancPeriods?.fourthANC?.startDate,
                    fourthAncEndDate: ancPeriods?.fourthANC?.endDate,
                    prevPregnancyClosureDetails: pregnancyFormState?.firstPregnancy?.value === "No" ? prevPregnancyClosureDetails :null,
                    totalChildrenLive: totalChildrenLive?.value || 0,
                    totalFemaleChildren: totalFemaleChild?.value || 0,
                    benfName: benfDetails?.benf_name,
                    abhaNumber: benfDetails?.abha_id,
                    mob: benfDetails?.mob,
                }
                const response = await postDataJSON<any>(`${endpoints.registerPregnancy}`, payLoad);
                dispatch(setShowPregnancy(false));
                setLmpDateError(false);
                setLmpDate('');
                dispatch(setBeneficiaryDetails([{...benfDetails, is_pregnant: true}]));
                dispatch(setCheckIsHrp(!checkIsHRP))
                setPregnancyFormState({
                    result: {
                        isError: false,
                        message: '',
                        isDisable: false,
                        value: '',
                    },
                    firstPregnancy: {
                        isError: false,
                        message: '',
                        id: '',
                        isDisable: false,
                        value: '',
                    },
                    dateOfRegistration: {
                        isError: false,
                        message: '',
                        isDisable: false,
                        value: '',
                    },
                    jsy: {
                        isError: false,
                        message: '',
                        id: '',
                        isDisable: false,
                        value: '',

                    },
                    facilityType: {
                        isError: false,
                        message: '',
                        isDisable: false,
                        value: '',
                    },
                    facilityName: {
                        isError: false,
                        message: '',
                        id: '',
                        isDisable: false,
                        value: '',
                    },
                    hprName: {
                        isError: false,
                        message: '',
                        isDisable: false,
                        value: '',
                    },
                    ashaName: {
                        isError: false,
                        message: '',
                        id: '',
                        isDisable: false,
                        value: '',
                    }
                });
                setMaximumDate(dayjs(new Date()).subtract(35, 'day'));
                dispatch(setShowServices(true));
                dispatch(setIsPregnant(true))
                setIsLMPDateDisable(true);
            }
            catch(error:any){
                errorLogger(error?.response?.data||error?.response||error)
                dispatch(setShowPregnancy(false));
            }
        }
    }

    const serviceCategoryNonPregnantOptions = localStorage.getItem('serviceCategoryNonPregnantOptions');

    const fetchServiceContent = async () => {
        let serviceContent: any = [];
        let serviceResponseData: any = {};
        try {
            if(storeUserId && serviceCategoryNonPregnantOptions) {
                serviceResponseData = JSON.parse(decodeWithKeyAndShift(serviceCategoryNonPregnantOptions));
                serviceContent = serviceResponseData?.data?.map((item: any) => item?.service_subcategory_name);
            }
            else{
                 serviceResponseData = await getDataWithCache<any>(endpoints.getServiceCategoryForNonPregnant);
                 serviceContent = serviceResponseData?.data?.map((item: any) => item?.service_subcategory_name);
                 localStorage.setItem('serviceCategoryNonPregnantOptions', encodeWithKeyAndShift(JSON.stringify(serviceResponseData)));
            }
            setServiceItems(serviceContent);
            setServiceData(serviceResponseData);
            return serviceContent;
        } catch (error:any) {
            errorLogger(error?.response?.data||error?.response||error);
        }
    };

    const serviceContent = {
        title: 'Add Services',
        subTitle: 'Services',
        content: serviceItems || [],
        data: serviceData?.data || [],
    };

    const handleshowAncModal = () => { 
        setShowANCModalFromTrackingPage(true);
    };
    return (
        <>
         {loading ? <div className="loader">Loading...</div> :
         <div>
        <div className="pregnancy_tracking_content">
            {canViewPregnancyOverview ? !showLoader && (pregnancyOngoing || showPregnancyServices || isPregnancyClosed)  ? (
                <>
                <PregnancyServices isPregnancyClosed={isPregnancyClosed} handleshowAncModal={() => handleshowAncModal()} addPregnancyOnClick={addPregnancyOnClick}/>
                </>
            ) : (!showLoader &&
                <>
                    <div className="pregnancy_form_content">
                        <div className="pregnancy_form">
                            {!pregnancyOngoing && !showPregnancyServices &&
                                <BadgesComponent
                                    className="over-badge"
                                    badgeName={showPregnancyForm ? "Pregnancy Registration" : 'Pregnancy Details'}
                                    variant="primary-1"
                                    badgeType="case5"
                                />
                            }
                            {!pregnancyOngoing && !showPregnancyForm && !showPregnancyServices &&
                                <div style={{ backgroundColor: '#8080802b', height: '90px', padding: '10px', width: '600px' }}>
                                    {COMMON_CONSTANTS.NO_PREGNANCY_TITLE}
                                </div>
                            }
                        </div>
                        {!pregnancyOngoing && !showPregnancyForm && !showPregnancyServices &&
                            <PregnancyActionButtons
                                isDead={benfDetails?.is_dead}
                                onAddServicesClick={() => setShowANCModalFromTrackingPage(true)}
                                onAddPregnancyClick={addPregnancyOnClick}
                                userRole={userRole}
                            />
                        }
                    </div>
                    {!pregnancyOngoing && showPregnancyForm && <div className="pregnancy_form_page_reg">
                        <form className="pregnancy_form_continaer">
                            <CommonFormFields
                                formData={pregnancyBenfFormData}
                                formState={pregnancyFormState}
                                handleFormChange={handlePregnancyFormChange}
                            />
                            <div className="lmpDate_wrapper">
                                <label
                                    className={`label-name-from-parent ${'yes'} ${false}`}
                                >
                                    {benef_const.lastMenstralDate}
                                </label>
                                <InputGroup>
                                    <DatePicker
                                        format={dateFormate.dd_mm_yyyy}
                                        title={benef_const.lastMenstralDate}
                                        placeholder={dateFormate.dd_mm_yyyy}
                                        maxDate={maximumDate}
                                        minDate={minimimDate}
                                        value={lmpDate ? dayjs(lmpDate) : undefined}
                                        disabled={isLMPDateDisable}
                                        onChange={handlelmpDateChange}
                                        className="dateOfDelivery"
                                        popupClassName="date-picker-popup-preg-register"
                                        suffixIcon={<VectorIcon/>}
                                        showTime={false}
                                        placement="bottomLeft"
                                        getPopupContainer={(trigger) => trigger.parentElement as HTMLElement}
                                        picker="date"
                                    />
                                </InputGroup>
                                <div className="input_field_infoBars">
                                    {(lmpDateError) && (
                                        <InfoBar
                                            variant="danger"
                                            message={'Select LMP Date'}
                                            className="input_field_class"
                                        />
                                    )}
                                </div>
                            </div>
                        </form>
                        {pregnancyFormState?.firstPregnancy?.value === "No" && <PregnancyOutcome
                                                   pregnancyFormState={pregnancyFormState}
                                                    numberOfPregnancy={numberOfPregnancy}
                                                    setNumberOfPregnancy={setNumberOfPregnancy}
                                                    totalChildrenLive={totalChildrenLive}
                                                    setTotalChildrenLive={setTotalChildrenLive}
                                                    totalFemaleChild={totalFemaleChild}
                                                    setTotalFemaleChild={setTotalFemaleChild}
                                                    outcomes={outcomes}
                                                    setOutcomes={setOutcomes}
                                                    lmpDate={lmpDate}
                                                    />}
                        <div className="cancel-edit">
                            <Button
                                onClick={handleSubmitForm}
                                disabled={pregnancyFormState.isError ? true : false}
                                id={''}
                                buttonName={buttonNames.submit}
                                colorType={'primary'}
                                iconPosition={'right'}
                            />
                        </div>
                    </div>}
                </>
            ) : <h2 style={{ padding: "20px" }}>Unauthorized</h2>}
        </div>
        {showANCModal && <PNCModal showModal={showANCModal} handleModalClose={() => setShowANCModalFromTrackingPage(false)} modalContent={serviceContent} />}
        {!pregnancyOngoing && showPregnancyCard &&
        <Modal
            show={showModal}
            onHide={() => {
                setShowPregnancyCard(false);
            }}
            dialogClassName={'pregnancy-card-modal'}
            centered={true}
            className='pregnancy-card'
            backdrop="static"
            >
            <Modal.Header>
                <div style={{ display: "flex", justifyContent: "space-between", gap: "400px" }}>
                    <div className="d-flex align-items-center beneficiary_back_button" onClick={handleBackClick}>
                        <i className="bi bi-arrow-left" style={{ cursor: "pointer" }} ></i>
                        <span className="ms-1">Back</span>
                    </div>
                    <div className="d-flex align-items-center beneficiary_discard_button" onClick={handleDiscardClick}>
                        <span className="me-0">Discard</span>
                        <i className="bi bi-x" ></i>
                    </div>

                </div>
            </Modal.Header>
            <Modal.Body  >
                <div className='pregnancy_card_option_modal'>
                    <h1 style={{ fontSize: '18px' }}>Pregnancy Test Result</h1>
                    <div className='card_content'>
                        {preganacyStatusData.map((status: any, key: number) => (
                            <span
                                key={key}
                                className='type_content' onClick={() => handleTestResultSelection(status.pregnancy_status_name)}
                                style={{
                                    backgroundColor: pregnancyTestResult === status.pregnancy_status_name ? '#af2d94' : 'white', color: pregnancyTestResult === status.pregnancy_status_name ? '#eaecf0' : '#656565',
                                    cursor: 'pointer', border: '1px solid gray'
                                }}>{status.pregnancy_status_name}
                            </span>
                        ))
                        }
                    </div>
                    <div className="card-submit">
                        <Button
                            onClick={handleSubmitTestResult}
                            disabled={!pregnancyTestResult}
                            id="prefnancy-type-submit"
                            buttonName={buttonNames.submit}
                            colorType={'primary'}
                            icon={''}
                            iconPosition={''} />
                    </div>
                </div>
            </Modal.Body>
        </Modal>}
        </div>}
        </>
    )
}

export default PregnancyTracking;